import { Component, ElementRef, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { EventsService } from '../../shared/Events.service';
import {ElectionService} from '../../shared/election-service/election.service';
import { SettingsService } from '../../shared/settings/settings.service';

import {Config} from '../../config';

@Component({
    selector: 'ballots-info',
    template: require('./ballots.component.html')

})
export class BallotsComponent implements OnInit {
    //  @Output() onValidLocation = new EventEmitter<boolean>();
      ballotsInfo: Object;
      isBallotInfoRetrieved:boolean = false;
      
      ballotFolder:string = "";
    //   ballotNotes:string = 'Notes:<br/><ol><li>Primary elections decide which major political party candidates will be on the ballot in November\'s general election. Indiana law requires voters participating in the primary election to request one of the following ballots: Democratic, Republican or Non-Partisan.</li><ol><li>Democratic and Republican ballots include their party candidates. Additionally, primary ballots include the final election in school board races, public questions, precinct committeeperson (Democratic only) and state convention delegate (Democratic and Republican).</li><li>Non-Partisan ballot only includes final elections for school board races and public questions.</li></ol><li>Indiana law permits 17 year old voters who will be 18 on or before November\'s general election (11/2/10) to participate in May\'s primary election. The ballot contains all races except for school board, precinct committeeperson, state convention delegate and public questions. These options are omitted from the 17 year old ballot because the contests are decided in the May primary election.</li></ol>';
    
      electionDatePrefix = "";

      tabActivated:boolean = false;
      appSettings: Object;
      error: any;
      
      private selectedAddressLocation:Object;

    constructor(private elRef: ElementRef, private _eventsService: EventsService, private _electionService: ElectionService, private _settingsService: SettingsService) { 

        
    }

    ngOnInit() {

         this._eventsService.selectedAddressObject$.subscribe(address => {
         
                //get the current address
                this.selectedAddressLocation = address["addressLocation"];


            }
            
        ); 

        //listen for when a search has been invoked
        this._eventsService.searchInvoked$.subscribe(
            address => {
                this.selectedAddressLocation = address["addressLocation"];
                this.isBallotInfoRetrieved = false;
                this.selectedAddressLocation ? this.getBallotsInformation() : console.log("Address location is undefined");
            }
        );

        // Get app settings from settings service      
        this.appSettings = Config.config[0];
        try{
            let currentTabSettings:Object = this.appSettings["widgets"].filter(item => { return item.name === 'Ballots'; });
            this.tabActivated = currentTabSettings[0].activate;
            this.ballotFolder = this.appSettings["ballotFolder"];
        }catch(err){
            this.error = true
        }
        

        // this._settingsService.getAppSettings().subscribe(
        //     settings => { 
        //         this.appSettings = settings[0];

        //         let currentTabSettings:Object = this.appSettings["widgets"].filter(item => { return item.name === 'Ballots'; });
        //         this.tabActivated = currentTabSettings[0].activate;
            
        //         this.ballotFolder = this.appSettings["ballotFolder"];
        
        //     },
        //     err => { this.error = true }
        // ); 

    }

    //get elected officials data
    getBallotsInformation() {
        //Get election date
        let electionDate = '';
        let electionName = '';

        if (this.appSettings["regularElection"]) {
            electionDate = this.appSettings["regularElectionDate"];
            if (this.appSettings["regularPrimary"]) {
                // electionName = this.i18nStrings.candidatesPrimaryElectionTitle + " " + electionDate;
            } else {
                // electionName = this.i18nStrings.candidatesRegularElectionTitle + " " + electionDate;
            }
        } else if (this.appSettings["specialElection"]) {
            electionDate = this.appSettings["specialElectionDate"];
            // electionName = this.i18nStrings.candidatesSpecialHeader + this.i18nStrings.candidatesSpecialElectionTitle + " " + electionDate;
        }
        if (electionDate != null) {
            let components = electionDate.split("/");
            if (components.length == 3) {
                let month = components[0];
                if (month.length == 1) { month = '0' + month; }
                let day = components[1];
                if (day.length == 1) { day = '0' + day; }
                let year = components[2];
                if (year.length == 2) { year = '20' + year; }
                this.electionDatePrefix = year.substr(2, 2) + month + day;
            }
        }
        this._electionService
            .getBallots(this.selectedAddressLocation["X"], this.selectedAddressLocation["Y"], (this.ballotFolder + "/" + this.electionDatePrefix + "_"), ".pdf")  //getOfficials(this.selectedAddressLocation["X"], this.selectedAddressLocation["Y"])
            .then(ballots => {
                //this._electionService.checkIfLinkIsAlive();

                 this.ballotsInfo = ballots

                 this.isBallotInfoRetrieved = true;
          
                }
            )
            .catch(error => {
                this.error = error
                console.log(this.error)
            });
    }
    



    ngOnDestroy() {

    }
    

}


// WEBPACK FOOTER //
// ./app/information/ballots/ballots.component.ts